/**
 * /public/css/form.css
 */

import React from "react";
import datefmt from "../../../part-panel/lib/datefmt";

export default function InputDate(props) {
    // Render component
    let Component = "input";

    const refInput = React.useRef();

    React.useEffect(() => {
        // Value
        const format = props.type === "date" ? "Y-M-D" : "h:m:s";
        const value = props.value && !isNaN(props.value) ? datefmt(props.value, format) : props.value;
        refInput.current.value = value;
    }, []);

    function onChange(event) {
        const valueAsNumber = event.target.valueAsNumber;

        if (isNaN(valueAsNumber)) {
            props.onChange({ name: props.name, value: "" });
            return;
        }

        if (props.type === "time") {
            props.onChange({
                name: props.name,
                value: datefmt(valueAsNumber - Math.abs(new Date(valueAsNumber).getTimezoneOffset() * 60000), "h:m"),
            });

            return;
        }

        props.onChange({ name: props.name, value: valueAsNumber });

        // !TODO Remove if unused
        // const d = new Date(event.target.valueAsNumber);
        // const dateNow = Date.now();

        // const initialDate = new Date(props.value || dateNow);
        // initialDate.setHours(0, 0, 0, 0);

        // const initialTime = new Date(new Date(props.value || initialDate) - initialDate.getTime());
        // initialTime.setSeconds(0, 0);

        // if (props.type === "date") {
        //     d.setTime(d.getTime() + d.getTimezoneOffset() * 60000);
        //     props.onChange({ name: props.name, value: d.getTime() + initialTime.getTime() });

        //     setShadowEndDate(d.getTime() + initialTime.getTime());
        // } else if (props.type === "time") {
        //     props.onChange({ name: props.name, value: initialDate.getTime() + d.getTime() });
        // }
    }

    // Trim
    let onBlur = props.onBlur;

    // Type (date || time)
    if (!props.type) {
        return null;
    }

    // Clean props
    const cleanProps = { ...props };
    delete cleanProps.value;
    delete cleanProps.small;
    delete cleanProps.fullWidth;
    delete cleanProps.trimOnBlur;

    // Combine component className
    const className = ["input-date"];

    // TODO! push
    Array.isArray(props.className) && className.push.call(className, props.className);
    typeof props.className === "string" && className.push(props.className);

    props.small && className.push("small");
    props.fullWidth && className.push("full-width");

    return (
        <>
            <Component
                ref={refInput}
                type={props.type}
                onBlur={onBlur}
                {...cleanProps}
                onChange={onChange}
                className={className.join(" ")}
            />

            {props.error !== undefined && <div className="input-base-error">{props.error || <>&nbsp;</>}</div>}
        </>
    );
}
